import { render } from "./Manage.vue?vue&type=template&id=54cbb9cf&scoped=true"
import script from "./Manage.vue?vue&type=script&lang=ts"
export * from "./Manage.vue?vue&type=script&lang=ts"

import "./Manage.vue?vue&type=style&index=0&id=54cbb9cf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54cbb9cf"

export default script